import { DefaultError, useMutation } from "@tanstack/react-query";
import { deletePageModule } from "../api/deletePageModule";
import { invalidateModuleListByBrandPageQuery } from "../queries/useModuleListByBrandPageQuery";

type Params = {
  brandId: string;
  pageId: string;
  moduleId: string;
  onSuccess: () => void;
};

export const useDeletePageModuleMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await deletePageModule({
        brandId: params.brandId,
        pageId: params.pageId,
        moduleId: params.moduleId,
      });
    },
    onSuccess: (_, params) => {
      invalidateModuleListByBrandPageQuery(params.brandId, params.pageId);
      params.onSuccess();
    },
  });
};
